export enum ECancelReason {
    NOSHOW = 'NoShow',
    CLIENT = 'Client',
    RESTAURANT = 'Restaurant',
}